import { addCollection } from '@iconify/vue'

export default defineNuxtPlugin(() => {
  addCollection({
    prefix: 'custom', // Prefix for your custom icons
    icons: {
      'risk-assessments': {
        body: '<path fill="currentColor" d="m2,12C2,6.48,6.48,2,12,2s10,4.48,10,10-4.48,10-10,10S2,17.52,2,12Zm2,0c0,4.41,3.59,8,8,8s8-3.59,8-8-3.59-8-8-8S4,7.59,4,12Zm8-4.5c-2.49,0-4.5,2.01-4.5,4.5s2.01,4.5,4.5,4.5,4.5-2.01,4.5-4.5-2.01-4.5-4.5-4.5Zm-1,4.5c0,.55.45,1,1,1s1-.45,1-1-.45-1-1-1-1,.45-1,1Z"/>',
        width: 24,
        height: 24,
      },
    },
  })
})
